import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
//create app
let vueapp = createApp(App);
//add vuex
vueapp.use(store);
//mount it
vueapp.mount('#mainapp');